export default __webpack_public_path__ + "static/media/KiwiMaru-Regular.34d31494.ttf";